(function() {
	'use strict';
	angular.module('app.setup')
		.service('poStatusCategoryService', poStatusCategoryService);

	poStatusCategoryService.$inject = ['$http', 'URLS'];
	function poStatusCategoryService($http, URLS) {
		return {
			addPoStatusCategory: addPoStatusCategory,
			updatePoStatusCategory: updatePoStatusCategory
		};

		function addPoStatusCategory(poStatusCategory) {
			return $http.post(URLS.host + String.format(URLS.poStatusCategories, globalConfig.customer.id), poStatusCategory)
				.then(addPoStatusCategorySuccess, handleError);

			function addPoStatusCategorySuccess(response) {
				return 'Supply Order Status Category created successfully';
			}
		}

		function updatePoStatusCategory(poStatusCategory, lastModified) {
			return $http.put(URLS.host + String.format(URLS.poStatusCategories, globalConfig.customer.id), poStatusCategory, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updatePoStatusCategorySuccess, updatePoStatusCategoryFailure);

			function updatePoStatusCategorySuccess(response) {
				return response;
			}

			function updatePoStatusCategoryFailure(response) {
				return response;
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 409) {
				return error.data.error;
			} else if (error.status === 412) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();